export default [
  {
    path: 'prizeRecord',
    name: 'PrizeRecord',
    meta: {
      title: '奖品记录'
    },
    component: () => import('../views/exerland/prizeRecord/index.vue')
  },
  {
    path: 'addressInfo',
    name: 'AddressInfo',
    meta: {
      title: '地址详情'
    },
    component: () => import('../views/exerland/prizeRecord/addressInfo.vue')
  }
]
